import { z } from 'zod';

export default z.object({
  email: z.string(),
  name: z.string(),
  id: z.number(),
});
